import React from 'react';
import { useNavigate } from 'react-router-dom';
// import '../components/UseCases.css';
import '../../../assets/guestportal.css'


const useCaseData = [
  {
    id: 'real-estate',
    title: 'Real Estate',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#F4F0FF"/>
        <path d="M16 36V20H32V36" stroke="#7B61FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="20" y="28" width="8" height="8" stroke="#7B61FF" strokeWidth="2.5" strokeLinejoin="round"/>
        <rect x="20" y="24" width="2" height="2" fill="#7B61FF"/>
        <rect x="26" y="24" width="2" height="2" fill="#7B61FF"/>
      </svg>
    ),
    lead: 'How Real Estate Companies Benefit from DocuSafe.ai',
    color: 'purple',
  },
  {
    id: 'lending-and-brokerage',
    title: 'Lending and Brokerage',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#E6F0FF"/>
        <path d="M16 32V20L24 14L32 20V32" stroke="#3B82F6" strokeWidth="2.5" strokeLinejoin="round"/>
        <rect x="20" y="28" width="8" height="8" stroke="#3B82F6" strokeWidth="2.5" strokeLinejoin="round"/>
      </svg>
    ),
    lead: 'Secure, Streamlined Document Management for Financial Services',
    color: 'blue',
  },
  {
    id: 'accounting-and-bookkeeping',
    title: 'Accounting and Bookkeeping',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#FCE7F3"/>
        <rect x="16" y="16" width="16" height="16" rx="4" stroke="#EC4899" strokeWidth="2.5"/>
        <rect x="20" y="20" width="8" height="8" fill="#EC4899"/>
      </svg>
    ),
    lead: 'Secure, Streamlined Document Management for Financial Services',
    color: 'pink',
  },
  {
    id: 'taxation',
    title: 'Taxation',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#FFF7ED"/>
        <rect x="16" y="16" width="16" height="16" rx="4" stroke="#F97316" strokeWidth="2.5"/>
        <path d="M20 24H28" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M24 20V28" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
    lead: 'Intelligent Document Management for Tax Professionals',
    color: 'orange',
  },
  {
    id: 'legal-services',
    title: 'Legal Services',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#E6FCE6"/>
        <rect x="16" y="16" width="16" height="16" rx="4" stroke="#10B981" strokeWidth="2.5"/>
        <path d="M24 20V28" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M20 24H28" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
    lead: 'Secure, Intelligent Document Management for Law Firms',
    color: 'blue',
  },
  {
    id: 'compliance',
    title: 'Compliance',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#F4F0FF"/>
        <path d="M16 32L24 16L32 32" stroke="#7B61FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="20" y="28" width="8" height="8" stroke="#7B61FF" strokeWidth="2.5" strokeLinejoin="round"/>
      </svg>
    ),
    lead: 'Automate, Organize, and Secure Your Regulatory Processes',
    color: 'purple',
  },
];

const UseCases2 = () => {
  const navigate = useNavigate();
  return (
    <section className="modern-use-cases">
      <div className="container">
      <div className="modern-use-cases-header">
        <h1 className="modern-use-cases-title">Explore Our <span>Use Cases</span></h1>
        <p className="modern-use-cases-subtitle">Discover how DocuSafe.ai transforms document management for key industries</p>
      </div>
      <div className="modern-use-cases-grid">
        {useCaseData.map((u) => (
          <div className="modern-use-case-card" key={u.id}>
            <div className={`modern-use-case-icon ${u.color}`}>{u.icon}</div>
            <h3 className="modern-use-case-title">{u.title}</h3>
            <p className="modern-use-case-lead">{u.lead}</p>
            <button
              className={`modern-use-case-btn ${u.color}`}
              onClick={() => navigate(`/use-cases/${u.id}`)}
            >
              Learn More
            </button>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default UseCases2;
